import { Injectable } from '@angular/core';
import { Firestore, doc, docData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { LegalEntityDocumentAttachment } from './legalEntityPractice.state.model';

@Injectable({
  providedIn: 'root'
})
export class LegalEntityPracticeQueryService {

  constructor(private dataService: Firestore) {}
  
  getPdfExport(legalEntityId: string): Observable<LegalEntityDocumentAttachment> {
    const docRef = doc(this.dataService, `legal-entity-documents/${legalEntityId}`);
    return docData(docRef) as Observable<LegalEntityDocumentAttachment>;
  }
}
